import { clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * cn — compose Tailwind classes with conditional logic, de-duplicating conflicts.
 * Usage: cn('px-3 py-2', isActive && 'bg-accent-600', className)
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

export default cn
